import * as React from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from "redux";
import ModalDialogError from "../Controls/ModalDialogError";
import { LoadingBar } from "../Controls/LoadingBar";
import { programmeCategoryStore } from "../../store/NonLinear/ProgrammeCategoryStore";
import { getStyleVisibility, getMandatoryBgCss } from '../../tools/toolkit';

class ProgrammeCategory extends React.Component {

    componentDidUpdate() {
        if (!this.props.hasErrorOccured && this.props.productionTypeUpdated) {
            this.props.getCategory(this.props.programmeId);
        }
    }

    handleErrorDialogClose = () => {
        this.props.clearErrorMessage();
    }

    handleProductionTypeChanged(level, productionTypeId) {
        this.props.updateLevel(this.props.programmeId, level, productionTypeId);
    }

    handleFormatChanged(formatId) {
        this.props.updateFormat(this.props.programmeId, formatId);
    }


    renderLevel1() {
        if (this.props.data.level1List) {
            return (
                this.props.data.level1List.map(item =>
                    <option key={item.id} value={item.id} selected={item.id === this.props.data.level1.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    renderLevel2() {
        if (this.props.data.level2List) {
            return (
                this.props.data.level2List.map(item =>
                    <option key={item.id} value={item.id} selected={item.id === this.props.data.level2.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    renderLevel3() {
        if (this.props.data.level3List) {
            return (
                this.props.data.level3List.map(item =>
                    <option key={item.id} value={item.id} selected={item.id === this.props.data.level3.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    renderFormat() {
        if (this.props.data.formatList) {
            return (
                this.props.data.formatList.map(item =>
                    <option key={item.id} value={item.id} selected={item.id === this.props.data.format.id}>{item.name}</option>
                )
            );
        }

        return '';
    }

    render() {
        return (
            <div>
                <div className='container-fluid pt-4'>
                    <div className='row bottomHorizontalRule'>
                        <h2 className='h2tablecell'>Programme Category</h2>
                    </div>
                    <div className='pl-2 pr-2'>
                        <div className='row'>
                            <div className='col-md-2 pt-1 pl-0'>
                                <label className='form-text'>Level 1<span className='mandatory' aria-hidden='true'> *</span></label>
                                <select id='level1' name='level1Id' className={'dropDownDefaults ' + getMandatoryBgCss(this.props.validationResult, 'publication_category', 'level_1')} defaultValue={this.props.data.level1 ? this.props.data.level1.id : ''} required disabled={!this.props.canEdit} onChange={(event) => this.handleProductionTypeChanged(1, event.target.value)} aria-label='Programme Category, Level 1'>
                                    <option value="">Select</option>
                                    {this.renderLevel1()}
                                </select>
                            </div>
                            <div className='col-md-2 pt-1 pl-0'>
                                <label className='form-text'>Level 2<span className='mandatory' aria-hidden='true' style={{ visibility: getStyleVisibility(this.props.data.isLevel2Required) }}> *</span></label>
                                <select id='level2' name='level2Id' className={'dropDownDefaults ' + getMandatoryBgCss(this.props.validationResult, 'publication_category', 'level_2')} defaultValue={this.props.data.level2 ? this.props.data.level2.id : ''} required={this.props.data.isLevel2Required} disabled={!this.props.canEdit || !this.props.data.isLevel2Required} onChange={(event) => this.handleProductionTypeChanged(2, event.target.value)} aria-label='Programme Category, Level 2'>
                                    <option value="">Select</option>
                                    {this.renderLevel2()}
                                </select>
                            </div>
                            <div className='col-md-2 pt-1 pl-0'>
                                <label className='form-text'>Level 3<span className='mandatory' aria-hidden='true' style={{ visibility: getStyleVisibility(this.props.data.isLevel3Required) }}> *</span></label>
                                <select id='level3' name='level3Id' className={'dropDownDefaults ' + getMandatoryBgCss(this.props.validationResult, 'publication_category', 'level_3')} defaultValue={this.props.data.level3 ? this.props.data.level3.id : ''} required={this.props.data.isLevel3Required} disabled={!this.props.canEdit || !this.props.data.isLevel3Required} onChange={(event) => this.handleProductionTypeChanged(3, event.target.value)} aria-label='Programme Category, Level 3'>
                                    <option value="">Select</option>
                                    {this.renderLevel3()}
                                </select>
                            </div>
                        </div>
                        <div className='row'>
                            <div className='col-md-2 pt-1 pl-0'>
                                <label className='form-text'>Format</label>
                                <select id='format' name='formatId' className='dropDownDefaults' defaultValue={this.props.data.format ? this.props.data.format.id : ''} disabled={!this.props.canEdit} onChange={(event) => this.handleFormatChanged(event.target.value)} aria-label='Programme Category, Format'>
                                    <option value="">Select</option>
                                    {this.renderFormat()}
                                </select>
                            </div>
                        </div>
                    </div>
                </div>
                <ModalDialogError id='errorModalDialogPR' errorData={this.props.errorData} onCloseClick={this.handleErrorDialogClose} hasErrorOccured={this.props.hasErrorOccured} />
                <LoadingBar isLoading={this.props.isLoading} />
            </div>
        );
    }
}

export default connect(
    state => state.programmeCategory,
    dispatch => bindActionCreators(programmeCategoryStore, dispatch)
)(ProgrammeCategory);


// WEBPACK FOOTER //
// ./src/components/NonLinear/ProgrammeCategory.js